import { useEffect, useState } from "react";
import Img from "@/components/Img";
import CustomerHeader, { CustomerFooter } from "@/components/customer/CustomerHeader";
import PropertyFooter from "@/components/customer/PropertyFooter";
import { http } from "@/lib/api";
import { useT } from "@/lib/i18n";
import { isCustomHost } from "@/pages/customer/PropertySite";

const KEY = "brand_pid";
export const setBrand = (pid) => sessionStorage.setItem(KEY, pid);
export const clearBrand = () => { if (!isCustomHost()) sessionStorage.removeItem(KEY); };
export const getBrand = () => sessionStorage.getItem(KEY);

export const useBrand = (pid, force = false) => {
  const [p, setP] = useState(null);
  const active = pid && (force || getBrand() === pid) ? pid : null;
  useEffect(() => {
    if (!active) { setP(null); return; }
    if (force) setBrand(active);
    http.get(`/public/properties/${active}/brand`).then((r) => setP(r.data)).catch(() => setP(null));
  }, [active, force]);
  return p;
};

export const brandHome = (p) => (!p ? "/" : isCustomHost() ? "/" : `/p/${p.slug}`);

const homeHref = (p) => (isCustomHost() ? "/" : `/p/${p.slug}`);

export const PropertyHeader = ({ p }) => {
  const t = useT();
  return (
    <header className="sticky top-0 z-50 border-b border-slate-200 bg-white/90 backdrop-blur-xl" data-testid="property-site-header">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-3 sm:px-6">
        <a href={p?.slug ? homeHref(p) : "#"} data-testid="property-site-home" className="min-w-0">
          {p?.logo ? <Img src={p.logo} size="sm" eager alt={p.name} className="h-10 w-auto max-w-[200px] object-contain" /> : <span className="block truncate font-heading text-lg font-bold text-[#1C1917] sm:text-xl">{p?.name}</span>}
        </a>
        <a href="/find-booking" data-testid="property-site-find-booking" className="shrink-0 rounded-lg px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100">{t("Cek Pesanan")}</a>
      </div>
    </header>
  );
};

export const BrandHeader = ({ brand }) => (brand ? <PropertyHeader p={brand} /> : <CustomerHeader />);
export const BrandFooter = ({ brand }) => (brand ? <PropertyFooter p={brand} findHref="/find-booking" /> : <CustomerFooter />);
